import React, { useEffect } from "react";
import { eventActions } from "../../_actions";
import { useDispatch, useSelector } from 'react-redux';
import { withTranslation, useTranslation } from "react-i18next";
import FormSelectbox from "../FormSelectbox/FormSelectbox";
import FormInput from "../FormInput/FormInput";
import "./ShipmentNoDate.scss";

function ShipmentNoDate(props) {

    const event = useSelector(state => state);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    function onSelectChange(event) {
        console.log(event);
    }

    function handleChange(event, name) {
        //setNewvalue(event, name)
        console.log(event, "event target", name);
    }

    const FontChange = useSelector((state) => state.fontsizechanger.fontsizechanger);

    return (
        <>
            <div className="shipment-no-date text-left d-none d-md-block">
                <p className="big-text" style={{ fontSize: `${FontChange}px` }}>{props.title}</p>
                <p className="small-text" style={{ fontSize: `${FontChange}px` }}><span className={props.class}><span className={props.fontSize}>{props.number ? props.number : ''}</span></span></p>
            </div>
            <div className="d-md-none mt-1">
                <table class="table table-borderless table-sm">
                    <tbody>
                        <tr>
                            <th scope="row" style={{ width: "155px" }} ><p className="bgNoText" style={{ fontSize: `${14}px`, color: " #929292", fontSize: "12px", textTransform: "uppercase" }}>{props.title}</p></th>
                            {<td><p className={"textDark bgNoText textWidth" + props.class} style={{ fontSize: `${12}px`, color: `${props.class}` }}>{props.number ? props.number : ''}</p></td>}
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default withTranslation()(ShipmentNoDate);